<template>
  <div class="kb-gallery" v-if="slides">
    <kb-fade-container v-if="animation == 'fade'" :images="slides" :isMobile="isMobile" @change="change" ref="swiperContainer" @mouseover.native="pauseAutoplay()" @mouseout.native="resumeAutoplay()">
      <kb-image-overlay class="d-flex flex-col">
        <h2>{{ slides[currentIndex].subtitle }}</h2>
        <h1>{{ slides[currentIndex].title }}</h1>
        <div class="spacer-h"></div>
        <div class="gallery-bar-container" v-if="slides.length > 1">
          <div v-for="(image, index) in slides" v-bind:key="index" class="gallery-bar-container__gallery-bar-hitbox" v-on:click="setIndex(index, true, $event)">
            <kb-gallery-bar :active="index == currentIndex" :hideIndicator="autoplayDisabled" :paused="timestampPaused !== null" :duration="duration"></kb-gallery-bar>
          </div>
        </div>
      </kb-image-overlay>
    </kb-fade-container>
    <kb-swiper-container v-if="animation == 'swipe'" :images="slides" :isMobile="isMobile" @change="change" ref="swiperContainer" @mouseover.native="pauseAutoplay()" @mouseout.native="resumeAutoplay()">
      <kb-image-overlay class="d-flex flex-col">
        <h2>{{ slides[currentIndex].subtitle }}</h2>
        <h1>{{ slides[currentIndex].title }}</h1>
        <div class="spacer-h"></div>
        <div class="gallery-bar-container" v-if="slides.length > 1">
          <div v-for="(image, index) in slides" v-bind:key="index" class="gallery-bar-container__gallery-bar-hitbox" v-on:click="setIndex(index, true, $event)">
            <kb-gallery-bar :active="index == currentIndex" :hideIndicator="autoplayDisabled" :paused="timestampPaused !== null" :duration="duration"></kb-gallery-bar>
          </div>
        </div>
      </kb-image-overlay>
    </kb-swiper-container>
  </div>
</template>

<script>
import { timer, Subscription } from "rxjs";
/**
 * A gallery with autoplay and support for touch devices.
 */
export default {
  name: 'kb-gallery',
  data: function() {
    return {
      currentIndex: 0,
      timerSubscription: null,
      timestampPaused: null,
      timestampLastChange: null,
      autoplayDisabled: false,
      isMobile: null
    }
  },
  props: {
    slides: {
      type: Array,
      required: true
    },
    duration: {
      type: Number,
      default: 3000
    },
    autoplay: {
      type: Boolean,
      default: true
    },
    animation: {
      type: String,
      default: 'fade'
    }
  },
  destroy: function() {
    window.removeEventListener('resize', this.handleResize);
  },
  mounted: function() {
    if(this.autoplay) {
      this.startAutoplay();
    }
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  methods: {
    handleResize: function($e) {
      this.isMobile = (window.innerWidth < 576);
    },
    change: function($e) {
      this.currentIndex = $e;
      this.disableAutoplay();
    },
    setIndex: function(index, disableAutoplay, $e) {
      if($e) {
        $e.preventDefault();
      }
      if(disableAutoplay) {
        this.disableAutoplay();
      }
      this.currentIndex = index;
      this.$refs.swiperContainer.setIndex(index);
    },
    startAutoplay: function(initialTimer, startIndex) {
      if(this.autoplayDisabled) {
        return;
      }
      this.timestampPaused = null;
      this.timerSubscription = timer(
        initialTimer || this.duration,
        this.duration
      ).subscribe(count => {
        const index = (count + (startIndex || 1)) % this.slides.length;
        this.timestampLastChange = +new Date();
        this.setIndex(index);
      });
    },
    stopAutoplay() {
      this.timerSubscription ? this.timerSubscription.unsubscribe() : void 0;
    },
    pauseAutoplay() {
      this.stopAutoplay();
      this.timestampPaused = +new Date();
    },
    resumeAutoplay() {
      if(this.autoplayDisabled) {
        return;
      }

      let timeRemaining = this.duration;
      if (this.timestampLastChange && this.timestampPaused) {
        timeRemaining = this.duration - (this.timestampPaused - this.timestampLastChange);
      }
      this.startAutoplay(timeRemaining, this.currentIndex + 1);
    },
    disableAutoplay() {
      this.autoplayDisabled = true;
      this.timestampPaused = null;
      this.stopAutoplay();
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/_breakpoints';
@import '../../../scss/_layout';

.kb-gallery {
  width: 100%;
  max-width: 950px;
  height: 334px;
  overflow: hidden;

  @media screen and (max-width: $breakPointMobile) {
    height: 410px;
  }
}

</style>